import Vue from "vue";

import Buefy from "buefy";
import "buefy/dist/buefy.css";

import VueI18n from "vue-i18n";
import VeeValidate from "vee-validate";
import VueTheMask from "vue-the-mask";
import Vue2Filters from "vue2-filters";
import VuePageTransition from "vue-page-transition";
import Notifications from "vue-notification";

import settings from "./environment";
import app from "./app/app";
import filters from "./app/shared/filters";
import router from "./app/app-routes";
import store from "./app/app-state";
import i18n from "./i18n/i18n";
import vuetify from "./plugins/vuetify";
import Toaster from "./plugins/toaster";
import { ValidationDict } from "./app/shared/services";

import "./styles/main.scss";
import "@mdi/font/css/materialdesignicons.css";
import "vue-tel-input/dist/vue-tel-input.css";

import VueGtm from "vue-gtm";
import VueYandexMetrika from "vue-yandex-metrika";

// import registerServiceWorker from "./app/shared/services/push-notifications/register-service-worker";
// registerServiceWorker();

// import '../public/registerServiceWorker';
import { initializeFirebase } from "./app/shared/services/push-notifications/push-notification";

initializeFirebase();

Vue.config.productionTip = false;

Vue.use(filters);
Vue.use(Notifications);
Vue.use(Buefy);
Vue.use(VueI18n);
Vue.use(Toaster);
Vue.use(VueTheMask);
Vue.use(Vue2Filters);
Vue.use(VeeValidate, { i18n, dictionary: ValidationDict });
Vue.use(VuePageTransition);
Vue.use(VueGtm, {
    id: settings.gtm,
});
Vue.use(VueYandexMetrika, {
    id: settings.yandex_metrika,
    router: router,
    env: "production",
});

export default new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(app),
}).$mount("#app");
